import React from "react";
import { TransferDto } from "domain/payload/response/bankamar/TransferResp";

interface Props {
  item: TransferDto;
  onClose: () => void;
}

const TransferDetailModal: React.FC<Props> = ({ item, onClose }) => {
  if (!item) return null;

  return (
    <div
      className="modal fade show"
      style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Transfer Detail</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <p><b>ID:</b> {item.id}</p>
            <p><b>Partner Customer ID:</b> {item.partnerCustomerId}</p>
            <p><b>Partner Customer Email:</b> {item.partnerCustomerEmail}</p>
            <p><b>Account Number:</b> {item.accountNumber}</p>
            <p><b>Status Code:</b> {item.statusCode}</p>
            <p><b>Event Type:</b> {item.eventType}</p>
            <p><b>Timestamp:</b> {item.timestamp}</p>

            <hr />
            <h6>Transaction Data</h6>
            <p><b>Transaction ID:</b> {item.transactionData?.transactionID}</p>
            <p><b>Credit Account:</b> {item.transactionData?.creditAccount}</p>
            <p><b>Credit Account Holder Name:</b> {item.transactionData?.creditAccountHolderName}</p>
            <p><b>Amount:</b> Rp {item.transactionData?.amount?.toLocaleString()}</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransferDetailModal;
